import React, { useEffect, useState } from 'react';
import '../css/layout-content.css'
import { Breadcrumb, Button, Col, Layout, Menu, message, Modal, Row, Select, theme } from 'antd';
import { Images } from '../assets';
import { matchRoutes, useLocation, useNavigate } from 'react-router-dom';
import { saveUserInfo } from '../redux/action';
import { useDispatch, useSelector } from 'react-redux';
import { LIST_MENU_SIDE_BAR } from '../constants/constants';
import { consoleLogUtil } from '../utils/consoleLogUtil';
import { getSelectedBranch, getVisibleMenu } from '../utils/funcHelper';
import { getListBranches } from '../services/apis';


const { Header, Content, Footer, Sider } = Layout;
const { confirm } = Modal;

const LayoutContent = ({ children }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [currentPathLabel, setCurrentPathLabel] = useState();
    const [collapsed, setCollapsed] = useState(false);
    const userReducer = useSelector(state => state?.userReducer);
    const [listMenu, setListMenu] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState(null); // Chi nhánh đã chọn
    const [isBranchModalVisible, setIsBranchModalVisible] = useState(false); // Hiển thị modal chọn chi nhánh
    const [dataBranches, setDataBranches] = useState([]);
    const [branchName, setBranchName] = useState('');
    const {
        token: { colorBgContainer },
    } = theme.useToken();

    const getDataBranches = async () => {
            try {
                const params = {
                    keyword: '',
                }
                const res = await getListBranches(params);
                if (res && res.status === 1) {
                    setDataBranches([...res?.data?.data]);
                } else {
                    setDataBranches([]);
                }
            } catch (error) {
                console.log('error', error);
            }
    }

    const useCurrentRoute = () => {
        if (location?.pathname == '/') return {}
        if (matchRoutes(LIST_MENU_SIDE_BAR, location)) {
            const [{ route }] = matchRoutes(LIST_MENU_SIDE_BAR, location);
            let routeCustom;
            if (route && route?.children) {
                routeCustom = {
                    ...route,
                    labelChil: route?.children?.find(obj => obj.path === location.pathname)?.label
                }
            } else {
                routeCustom = route;
            }
            return routeCustom
        } else {
            return {}
        }
    }
    const handleGetBreadcrumb = () => {
        if (location?.pathname == '/') {
            setCurrentPathLabel('');
        }
        LIST_MENU_SIDE_BAR.forEach(menu => {
            if (menu.path === location.pathname) {
                setCurrentPathLabel(menu.label);
            } else {
                if (menu.children) {
                    const chil = menu.children.find(obj => obj.path === location.pathname);
                    if (chil) {
                        setCurrentPathLabel(`${menu.label}/${chil.label}`);
                    }
                }
            }
        })
    }
    const handlePermissionMenu = () => {
        const menuForUser = getVisibleMenu(userReducer?.data?.roles?.map(item => parseInt(item.id)), LIST_MENU_SIDE_BAR);
        setListMenu([...menuForUser]);
    }

    const handleCLickMenu = (item) => {
        if (item.key == 'dang-xuat') {
            confirm({
                title: <>Bạn có chắc chắn muốn đăng xuất?</>,
                okText: "OK",
                okType: "danger",
                cancelText: "Hủy",
                async onOk() {
                    try {
                        dispatch(saveUserInfo(null));
                    } finally {
                    }
                },
            });
        } else {
            navigate(`/${item.key}`, { replace: true });
        }
        // saveLog(item?.key);
    }

    const handleBranchSelect = (branchId) => {
        const branch = dataBranches.find(b => b.id === branchId);
        if (branch) {
            setSelectedBranch(branch);
        }
    };

    const handleSaveBranchToLocalStorage = () => {
        if (!selectedBranch) {
            message.error('Vui lòng chọn chi nhánh!');
            return;
        }
        if (selectedBranch) {
            localStorage.setItem('selectedBranch', JSON.stringify(selectedBranch));
            setIsBranchModalVisible(false);
            message.success(`Đã chọn chi nhánh: ${selectedBranch.name}`);
        }
    }

    useEffect(() => {
        handleGetBreadcrumb();
    }, [location])
    useEffect(() => {
        if (userReducer?.data?.roles) {
            consoleLogUtil("vao day");
            handlePermissionMenu();
        }
    }, [userReducer?.data?.access_token, userReducer?.data?.roles, userReducer])

    useEffect(() => {
        // Kiểm tra chi nhánh đã chọn trong localStorage
        if (!userReducer?.data?.access_token) {
            setIsBranchModalVisible(false);
            setBranchName('');
            return;
        };
        const savedBranch = getSelectedBranch();
        if (savedBranch) {
            setSelectedBranch(savedBranch);
            setIsBranchModalVisible(false); // Ẩn modal nếu đã chọn chi nhánh
            setBranchName(savedBranch.name);
        } else {
            setIsBranchModalVisible(true); // Hiển thị modal nếu chưa chọn chi nhánh
        }
    }, [userReducer?.data?.access_token, userReducer?.data?.roles, userReducer]);

    useEffect(() => {
        getDataBranches();
    }, []);

    return (
        <Layout
        style={{ minHeight: '100vh' }}
        >
            <Sider 
                width={280} 
                collapsible 
                collapsed={collapsed} 
                onCollapse={(value) => setCollapsed(value)} 
                theme='light'
                style={{
                    boxShadow: "2px 0 8px rgba(0,0,0,0.1)",  // 👈 đổ bóng bên phải sider
                    zIndex: 9
                  }}
            >
                <div className="logo-vertical" >
                    <img src={Images.img_logo_app} className='img-logo' />
                </div>
                <Menu theme="light" defaultSelectedKeys={useCurrentRoute()?.key} mode="inline" items={listMenu} onClick={handleCLickMenu} style={{fontSize: 16}}/>
            </Sider>
            <Layout style={{ minHeight: '100vh' }}>
                <Header
                    className='color-header header-padding'
                    style={{
                        boxShadow: "0 8px 6px rgba(0,0,0,0.08)",  // 👈 đổ bóng cho header
                        zIndex: 10,
                        position: "sticky",
                        top: 0
                      }}
                    >
                    <Row>
                        <Col span={15}>
                            <p className='title-header'>Hệ thống quản lý Ruby Luxury</p>
                        </Col>
                        <Col span={9}>
                            <p className='user-name-header'><span className='txt-hello'>Xin chào</span>, {userReducer?.data?.user_info?.fullname} - {branchName}</p>
                        </Col>
                    </Row>
                    
                </Header>
                <Content
                    style={{
                        margin: '0 16px 0 24px',
                    }}
                >
                    <Breadcrumb
                        style={{
                            margin: '16px 0',
                        }}
                    >
                        <Breadcrumb.Item>{currentPathLabel}</Breadcrumb.Item>
                    </Breadcrumb>
                    <div
                        style={{
                            paddingTop: 24,
                            paddingBottom: 24,
                            paddingLeft: 12,
                            paddingRight: 12,
                            background: "#FFF",
                            minHeight: `calc(100vh - 180px)`,
                            border: `1px solid #e7e7e7`,
                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                            borderRadius: 0
                        }}
                        className='height-body'
                    >
                        {children}
                    </div>
                </Content>
                <Footer
                    style={{
                        textAlign: 'center',
                        background: 'transparent'
                    }}
                >
                    Bản quyền thuộc Spa Ruby ©2025
                </Footer>
            </Layout>
            {/* Modal chọn chi nhánh */}
            <Modal
                title="Chọn chi nhánh làm việc"
                visible={isBranchModalVisible}
                footer={null}
                closable={false}
            >
                <Select
                    placeholder="Chọn chi nhánh"
                    style={{ width: '100%' }}
                    onChange={handleBranchSelect}
                    options={dataBranches.map(branch => ({
                        value: branch.id,
                        label: branch.name,
                    }))}
                    value={selectedBranch ? selectedBranch.id : undefined}
                />
                <Button
                    type="primary"
                    style={{ marginTop: 16, width: '100%' }}
                    onClick={() => {
                        handleSaveBranchToLocalStorage();
                    }}
                >
                    Xác nhận
                </Button>
            </Modal>
        </Layout>
    );
};
export default LayoutContent;